<template>
	<v-dialog v-model="showDialog" max-width="900" overlay-opacity="0.9">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">製品検索</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-4">
				<v-form class="pa-2 mt-2" ref="form" lazy-validation>
					<v-row>
						<v-col cols="10">
							<v-text-field
								type="text"
								v-model="searchProductNumber"
								class="mt-2 mx-1"
								label="製造番号で検索"
								outlined
								dense
							/>
						</v-col>
						<v-col cols="2">
							<v-btn
								:disabled="!searchProductNumber.length > 0"
								class="mt-2 mx-1"
								color="primary"
								@click="searchOrderedComponent()"
							>
								<v-icon>mdi-magnify</v-icon>検索
							</v-btn>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="10">
							<v-text-field
								type="text"
								v-model="searchMatterName"
								class="mt-2 mx-1"
								label="案件名で検索"
								outlined
								dense
							/>
						</v-col>
						<v-col cols="2">
							<v-btn
								:disabled="!searchMatterName.length > 0"
								class="mt-2 mx-1"
								color="primary"
								@click="searchMatters()"
							>
								<v-icon>mdi-magnify</v-icon>検索
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
				<div class="table-container mt-6" v-if="openDataTable && productNumberFlag">
					<v-data-table
						locale="ja-JP"
						:headers="productHeaders"
						:items="order_components"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr @click="selectProduct(item.ordered_product_id)">
								<td>{{ item.ordered_product.product_number }}</td>
								<td>{{ item.ordered_product.product.name }}</td>
								<td>{{ item.ordered_product.sub_name }}</td>
								<td>{{ item.ordered_product.quantity }}</td>
								<td>{{ item.ordered_product.matter.regular_customer.name }}</td>
							</tr>
						</template>
					</v-data-table>
					<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
				</div>
				<div class="table-container mt-6" v-if="openDataTable && matterFlag">
					<v-data-table
						locale="ja-JP"
						:headers="matterHeaders"
						:items="matters"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr @click="selectMatter(item)">
								<td>{{ item.name }}</td>
								<td>{{ item.quotation_number }}</td>
								<td>{{ item.order_number }}</td>
							</tr>
						</template>
					</v-data-table>
					<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
				</div>
				<MatterProductsDialog
					:dialog.sync="matterProductFlag"
					:matter="matter"
					@selectProduct="selectProduct"
					@selectMatterProduct="selectMatterProduct"
					@close="matterProductFlag = false"
				/>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import PaginationModule from "../../../modules/PaginationModule.vue"
import MatterProductsDialog from "../component/MatterProductsDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		PaginationModule,
		MatterProductsDialog,
	},
	data() {
		return {
			searchMatterName: "",
			searchProductNumber: "",
			order_components: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			productHeaders: [
				{ text: "製造番号", value: "product_number", width: "200px", divider: true },
				{ text: "製品名", value: "name", width: "200px", divider: true },
				{ text: "サブネーム", value: "sub_name", width: "200px", divider: true },
				{ text: "台数", value: "quantity", width: "70px", divider: true },
				{ text: "得意先", value: "regular_customer", width: "250px", divider: true },
			],
			matterHeaders: [
				{ text: "案件名", value: "name", width: "200px", divider: true },
				{ text: "見積番号", value: "quotation_number", width: "200px", divider: true },
				{ text: "受注番号", value: "order_number", width: "200px", divider: true },
			],
			openDataTable: false,
			productNumberFlag: false,
			matterFlag: false,
			matters: [],
			matter: {},
			matterProductFlag: false,
		}
	},

	methods: {
		getPage(page) {
			if (this.productNumberFlag) {
				this.searchOrderedComponent(page)
			}
			if (this.matterFlag) {
				this.searchMatters(page)
			}
		},

		searchOrderedComponent(page) {
			const headers = authenticate.setHeader()
			this.matterFlag = false
			const params = {
				ordered_product_product_number_cont: this.searchProductNumber,
			}
			axios
				.get(`/erp/v1/order_data/search_order_components`, {
					headers,
					params: { q: params, page },
				})
				.then((res) => {
					this.order_components = res.data.order_components
					this.openDataTable = true
					this.pagination = res.data.pagination
					this.productNumberFlag = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		searchMatters(page) {
			const headers = authenticate.setHeader()
			this.productNumberFlag = false
			const params = {
				name_cont: this.searchMatterName,
			}
			axios
				.get(`/erp/v1/order_data/search_matters`, {
					headers,
					params: { q: params, page },
				})
				.then((res) => {
					this.matters = res.data.matters
					this.openDataTable = true
					this.pagination = res.data.pagination
					this.matterFlag = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		selectProduct(orderedProductId) {
			const displayBtn = true
			this.$emit("selected-product", orderedProductId, displayBtn)
			this.showDialog = false
		},
		selectMatter(matter) {
			this.matter = matter
			this.matterProductFlag = true
		},

		selectMatterProduct(matterProductId, displayBtn) {
			this.showDialog = false
			this.$emit("selected-matter-product", matterProductId, displayBtn)
		},
	},

	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>
